// Picks up a new deploy in a tab or installed app that never reloads.
//
// index.html is served with max-age=0 and the service worker has no fetch
// handler, so any fresh load already gets the newest build. What does not is a
// page that stays open: an installed app on a phone is suspended and resumed,
// not reloaded, and can run last week's bundle for days. So when the page comes
// back to the foreground after being away a while, fetch index.html uncached
// and compare its main bundle with the one this page is running. If they
// differ, reload, unless something typed on screen would be lost; then the
// next resume tries again.

const AWAY_MS = 60 * 1000;          // shorter absences (a notification glance) are left alone
const MIN_INTERVAL_MS = 5 * 60 * 1000;

const BUNDLE_RE = /\/static\/js\/main\.[a-f0-9]+\.js/;

function runningBundle() {
  const el = document.querySelector('script[src*="/static/js/main."]');
  const m = el && el.getAttribute('src').match(BUNDLE_RE);
  return m ? m[0] : null;
}

async function deployedBundle() {
  const res = await fetch('/index.html', { cache: 'no-store' });
  if (!res.ok) return null;
  const m = (await res.text()).match(BUNDLE_RE);
  return m ? m[0] : null;
}

// A password field (sign-in, or a reset link whose token is already spent) or
// any field with text in it means a reload may cost the user something. Not
// value !== defaultValue: React keeps the value attribute in sync on controlled
// inputs, so that comparison never fires.
function hasUnsavedInput() {
  if (document.querySelector('input[type="password"]')) return true;
  return [...document.querySelectorAll('input, textarea')].some(el =>
    !['hidden', 'checkbox', 'radio', 'range', 'button', 'submit'].includes(el.type)
    && el.value.trim() !== '');
}

export function startVersionCheck() {
  if (process.env.NODE_ENV !== 'production') return;
  const running = runningBundle();
  if (!running) return;

  let hiddenAt = null;
  let lastCheck = Date.now();

  const check = async (away) => {
    if (away < AWAY_MS || Date.now() - lastCheck < MIN_INTERVAL_MS) return;
    lastCheck = Date.now();
    try {
      const deployed = await deployedBundle();
      if (deployed && deployed !== running && !hasUnsavedInput()) window.location.reload();
    } catch { /* offline or blocked · try again next time */ }
  };

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') { hiddenAt = Date.now(); return; }
    const away = hiddenAt ? Date.now() - hiddenAt : 0;
    hiddenAt = null;
    check(away);
  });
  // Restored from the back/forward cache (iOS does this to an installed app)
  // without a visibility event in between: treat it as a long absence.
  window.addEventListener('pageshow', (e) => { if (e.persisted) check(Infinity); });
}
